import React from "react";
import { PodcastGroupLineLoaderTemplate } from "themes/administration/podcast/components";

function PodcastGroupLineLoader(props) {
    return <PodcastGroupLineLoaderTemplate {...props} />;
}

export default PodcastGroupLineLoader;
